import axios from './axiosConfig'
import type { InvoicePayments, InvoiceSafeTotals } from 'Types/Invoice'
import type { PaginatedResponse } from 'Types/common'
import { optionalStartEndDateParams } from 'helpers/optionalDateParams'

interface PaymentListParams {
 page?: number
 limit?: number
 term?: string
 sort_by?: string
 sort_direction?: 'asc' | 'desc'
 filter?: {
  payment_method?: string | null
  start_date?: string | null
  end_date?: string | null
  invoice_number?: string | null
  phone_number?: string | null
 }
}

interface SafeTotalsParams {
 start_date?: string | null
 end_date?: string | null
}

function cleanPaymentListParams(params?: PaymentListParams): PaymentListParams | undefined {
 if (!params) return params
 const cleaned: PaymentListParams = { ...params }
 if (!cleaned.filter) return cleaned

 const { payment_method, invoice_number, phone_number, start_date, end_date } = cleaned.filter
 const nextFilter: PaymentListParams['filter'] = {
  ...optionalStartEndDateParams(start_date, end_date),
 }
 if (payment_method) nextFilter.payment_method = payment_method
 if (invoice_number) nextFilter.invoice_number = invoice_number
 if (phone_number) nextFilter.phone_number = phone_number

 cleaned.filter = Object.keys(nextFilter).length ? nextFilter : undefined
 return cleaned
}

export const paymentsAPI = {
 getAll: async (params?: PaymentListParams): Promise<PaginatedResponse<InvoicePayments>> => {
  const response = await axios.get('/mcp/invoices/payments/list', { params: cleanPaymentListParams(params) })
  return response.data
 },

 getSafeTotals: async (params?: SafeTotalsParams): Promise<InvoiceSafeTotals> => {
  const response = await axios.get('/mcp/invoices/safe-totals', {
   params: optionalStartEndDateParams(params?.start_date, params?.end_date),
  })
  return response.data
 },
}
